import { cn } from "@/domains/library"

export const DesktopNavLayout = ({
  logo,
  navigationDropdownBar,
  buttons,
}: {
  logo: React.ReactNode
  navigationDropdownBar: React.ReactNode
  buttons: React.ReactNode
}) => {
  return (
    <div className={cn("flex items-center justify-between gap-2 px-4 py-6")}>
      <div>{logo}</div>
      <div>{navigationDropdownBar}</div>
      <div>{buttons}</div>
    </div>
  )
}
